import { render, staticRenderFns } from "./questRewards.vue?vue&type=template&id=26fb5aa2&scoped=true"
import script from "./questRewards.vue?vue&type=script&lang=js"
export * from "./questRewards.vue?vue&type=script&lang=js"
import style0 from "./questRewards.vue?vue&type=style&index=0&id=26fb5aa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fb5aa2",
  null
  
)

export default component.exports